import React from "react";
import useFetcher from "../../../../../hooks/useFetcher";
import { fetchTareasByClientes } from "../../../../../services/reportingServices";
import { BlurSpinner } from "../../../../../components/BlurSpinner";
//
const Table = ({ filters }) => {
  const currentPage = 1;
  const itemsPerPage = 1;
  const sort = { sortBy: "vencido", sortDirection: "desc" };

  // eslint-disable-next-line no-unused-vars
  const [data, isLoading, error, setData, fetchData] = useFetcher(fetchTareasByClientes, [
    { ...filters, page: currentPage, perpage: itemsPerPage, orderBy: sort.sortBy, orderType: sort.sortDirection },
  ]);

  if (!data || !data.rows || !data.rows[0]) {
    return <></>;
  }

  return (
    <BlurSpinner isLoading={(!data, isLoading)}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 15,
          }}
        >
          <div>
            <p style={{ margin: 0 }}>Razón social</p>
            <h4>{data.rows[0].razonSocial}</h4>
          </div>

          <div
            style={{
              width: "100px",
              backgroundColor: "#f7f3f3",
              padding: "15px",
              borderRadius: "20px",
            }}
          >
            <p style={{ margin: 0, fontSize: 10 }}>Venc. Depto.</p>
            <span style={{ fontSize: 18 }}>{data.rows[0].vencido}</span>
          </div>

          <div
            style={{
              width: "100px",
              backgroundColor: "#f7f3f3",
              padding: "15px",
              borderRadius: "20px",
            }}
          >
            <p style={{ margin: 0, fontSize: 10 }}>Venc. Gral.</p>
            <span style={{ fontSize: 18 }}>{data.rows[0].vencidoTotal}</span>
          </div>

          <div
            style={{
              width: "100px",
              backgroundColor: "#f7f3f3",
              padding: "15px",
              borderRadius: "20px",
            }}
          >
            <p style={{ margin: 0, fontSize: 10 }}>Pendientes</p>
            <span style={{ fontSize: 18 }}>{data.rows[0].pendiente}</span>
          </div>

          <div
            style={{
              width: "100px",
              backgroundColor: "#f7f3f3",
              padding: "15px",
              borderRadius: "20px",
            }}
          >
            <p style={{ margin: 0, fontSize: 10 }}>Total</p>
            <span style={{ fontSize: 18 }}>{data.rows[0].resuelto + data.rows[0].pendiente + data.rows[0].vencidoTotal}</span>
          </div>
        </div>
      </div>
    </BlurSpinner>
  );
};

export default Table;
